<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditBasicForm" :rules="addEditBasicRules" ref="addEditBasicForm" label-width="100px" class="demo-ruleForm">
    <el-row>
      <el-col :span="16">
        <el-form-item label="员工姓名" prop="service_personnel_name">
          <el-input v-model="addEditBasicForm.service_personnel_name" placeholder="请输入员工姓名"></el-input>
        </el-form-item>
<!--        <el-form-item label="所属机构" prop="e_id">-->
<!--          <el-select v-fixZoom v-model="addEditBasicForm.e_id" filterable placeholder="请选择" style="width: 100%">-->
<!--            <el-option v-for="item in entityArr" :key="item.id" :label="item.entity_name" :value="item.id">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-row>
          <el-col :span="14">
            <el-form-item label="手机号" prop="">
              <el-input v-model="addEditBasicForm.service_personnel_contact_number" placeholder="请输入正确手机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="性别" prop="service_personnel_gender">
              <el-radio-group v-model="addEditBasicForm.service_personnel_gender">
                <el-radio :label="'1'">男</el-radio>
                <el-radio :label="'2'">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="所属组织" prop="orgid">
          <el-cascader v-fixZoom style="width: 100%" :options="treeOrg"
                       v-model="addEditBasicForm.orgid" :filterable="true" placeholder="请选择组织"
                       :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                       ref="orgOptions">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <div style="width: 90px;margin: auto">
          <el-upload class="avatar-uploader" action="#" :auto-upload="false" :show-file-list="false"
            :on-exceed="handleExceed" :before-upload="beforeUpload" :on-change="getFile"
            list-type="picture" :file-list="fileList">
            <img v-if="addEditBasicForm.service_personnel_photo" :src="addEditBasicForm.service_personnel_photo" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div style="font-size: 16px;text-align: center;color: #409EFF">
          <span v-if="isAddPerson">上传头像</span>
          <span v-if="!isAddPerson">更新头像</span>
        </div>
        <div style="font-size: 14px;text-align: center;color: #999999"><span>jpeg/jpg/png格式</span></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="服务状态" prop="">
          <el-radio-group v-model="addEditBasicForm.service_personnel_service_status_code">
            <el-radio :label="'1'">正常服务</el-radio>
            <el-radio :label="'2'">停止服务</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="服务密码" prop="">
          <el-input v-model="addEditBasicForm.auth_code" placeholder="请输入服务密码"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEditUnit('addEditBasicForm')">
          <span v-if="isAdd">确定新增</span>
          <span v-else>确定更新</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {createserviceperson, updateserviceperson, uploadfile} from '../../../api/yanglaoyuan'

export default {
  name: 'basicStaff',
  props: {
    basicObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      treeOrg: [],
      // 头像
      fileList: [],
      isAddPerson: true,
      imageUrl: '',
      entityArr: [],
      addEditBasicForm: {
        orgid: '',
        service_personnel_name: '',
        service_personnel_gender: '',
        service_personnel_photo: '',
        service_personnel_contact_number: '',
        service_personnel_service_status_code: '',
        e_id: 1,
        auth_code: ''
      },
      addEditBasicRules: {
        service_personnel_name: [{required: true, message: '请输入服务人员姓名', trigger: 'blur'}],
        service_personnel_gender: [{required: true, message: '请选择性别', trigger: 'change'}],
        orgid: [{required: true, message: '请选择组织', trigger: 'change'}]
        // e_id: [{required: true, message: '请选择所属机构', trigger: 'change'}]
      },
      isAdd: true
    }
  },
  created () {
    // console.log(this.basicObj)
    this.entityArr = this.basicObj.entityArr
    this.addEditBasicForm = this.basicObj.formServicePerson
    this.treeOrg = this.basicObj.treeOrg
    this.isAdd = this.basicObj.isAdd
  },
  methods: {
    // 头像
    beforeUpload (file) {
      console.log(111, file, file.type)
    },
    getFile (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      let obj = {
        raw: file.raw,
        filename: '头像',
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传', type: 'success' })
        this.addEditBasicForm.service_personnel_photo = res.data.fileurl
      }).catch(() => {
        this.$message.closeAll()
        this.addEditBasicForm.service_personnel_photo = ''
        this.imageUrl = ''
        this.$message({ message: '上传失败', type: 'error' })
      })
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    closeAddEdit () {
      this.$emit('changeEndBasic', {type: 'close'})
    },
    submitAddEditUnit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            createserviceperson(this.addEditBasicForm).then(res => {
              this.addEditBasicForm.id = res.data.id
              this.isAdd = false
              let obj = {
                type: 'isBtnBasic',
                form: this.addEditBasicForm
              }
              this.$emit('changeEndBasic', obj)
              this.$notify({title: '成功', message: '成功添加员工', type: 'success', duration: 2000})
            }).catch(() => {})
          } else {
            updateserviceperson(this.addEditBasicForm).then(res => {
              this.isAdd = false
              let obj = {
                type: 'isBtnBasic',
                form: this.addEditBasicForm
              }
              this.$emit('changeEndBasic', obj)
              this.$notify({title: '成功', message: '成功编辑员工', type: 'success', duration: 2000})
            }).catch(() => {})
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/basicStaff.vue